import { render } from "./DeGuild.vue?vue&type=template&id=59dbcff9"
import script from "./DeGuild.vue?vue&type=script&lang=js"
export * from "./DeGuild.vue?vue&type=script&lang=js"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__